module.exports = __webpack_public_path__ + "static/media/raise-or-fold-intro-screen.acb599f3.png";